import { render } from "./UIDesign.vue?vue&type=template&id=411f6403&scoped=true"
import script from "./UIDesign.vue?vue&type=script&lang=js"
export * from "./UIDesign.vue?vue&type=script&lang=js"

import "./UIDesign.vue?vue&type=style&index=0&id=411f6403&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-411f6403"]])

export default __exports__